import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  isLoggedIn(): boolean {
    const loginDetails = localStorage.getItem('loginDetails');
    return loginDetails !== null && loginDetails !== undefined;
  }

  getLoginDetails(): any {
    const loginDetails = localStorage.getItem('loginDetails');
    return loginDetails ? JSON.parse(loginDetails) : null;
  }
}
